/**
 * Workplace/Facility type constants for appV2
 *
 * These constants define the various types of workplaces/facilities
 * supported by the application.
 */

export const WORKPLACE_TYPES = {
  LONG_TERM_CARE: "Long Term Care",
  HOSPICE: "Hospice",
  HOME_HEALTHCARE: "Home Healthcare",
  PSYCH_HOSPITAL: "Psych Hospital",
  MEDICAL_LAB: "Medical Lab",
  HOSPITAL: "Hospital",
  DENTAL_CLINIC: "Dental Clinic",
  SCHOOL: "School",
  CHILD_CARE_CENTER: "Child Care Center",
  BEHAVIORAL_HEALTH: "Behavioral Health",
  OTHER: "Other",
} as const;

export type WorkplaceType = (typeof WORKPLACE_TYPES)[keyof typeof WORKPLACE_TYPES];

export const ALL_WORKPLACE_TYPES = Object.values(WORKPLACE_TYPES);
